import React from 'react'

import { Typography, useDimensions } from '@telavita-core/react-design-kit'

import Toggle from 'components/Toggle'

import { CardWrapper } from '../CardWrapper'
import { useTranscriptionService } from 'services/me/preferences'

import * as S from './styles'

export const TranscriptionAuthorizerSettings = (): JSX.Element => {
  const { data, mutate } = useTranscriptionService()

  const { isMobile } = useDimensions()

  const isAuthorized = data === true

  const handleToggle = (value: boolean) => {
    mutate(!value)
  }

  return (
    <CardWrapper
      title='Transcrição da consulta'
      subtitle={
        <Typography variant="content3">Para permitir, a <b>gravação do áudio da consulta</b> deve estar ativada</Typography>
      }
    >
      <S.TranscriptionAuthorizerSettingsContainer isMobile={isMobile}>
        <div>
          <Typography variant="content2">
            ✔ Garante um registro mais detalhado das informações e melhora o acompanhamento e a eficiência do tratamento
          </Typography>
          <Typography variant="content2">
            ✔ Ajuda seu psicólogo a ter uma visão mais precisa do seu processo
          </Typography>
        </div>

        <S.ToggleContainer isMobile={isMobile}>
          <S.ToggleWrapper>
            <Typography variant="content3" weight='light'>
              Ativada
            </Typography>
            <Toggle
              isToggled={isAuthorized}
              onToggledSwitch={handleToggle}
              toggleId='toggle-transcription-authorizer'
              value={isAuthorized}
            />
          </S.ToggleWrapper>
        </S.ToggleContainer>
      </S.TranscriptionAuthorizerSettingsContainer>
    </CardWrapper>
  )
}
